import a3 from "../imgs/banner.jpg"
import Shop from "./Shop";
import l1 from "../imgs/left.jpg"
import r1 from "../imgs/right.jpg"
import log from "../imgs/logo.jpg"
import w1 from "../imgs/web1.jpg"
import w2 from "../imgs/web2.jpg"
import w3 from "../imgs/web3.jpg"
import w4 from "../imgs/web4.jpg"
import { useEffect, useState } from "react";

const Home = () => {
    const wbimages = [w1, w2, w3, w4];
    const [ind, setind] = useState(0);

    setTimeout(() => {
        if (ind != 3) {
            setind(ind + 1)
        }
        else{
            setind(0);
        }
    }, 100 * 100)
    return (
        <>
            <img src={a3} className="img-fluid mt-3" layout="responsive" />

            <div className="frow mt-4">
                <div className="cli">
                    <i class="fa-solid fa-truck"> </i>
                    <p> <b>  Free Shipping  </b><br />
                        On all orders
                    </p>
                </div>
                <div className="cli">
                    <i class="fa-solid fa-clock"></i>
                    <p> <b> Easy Returns  </b><br />
                        30 day return policy
                    </p>
                </div>
                <div className="cli">
                    <i class="fa-solid fa-shield-halved"></i>
                    <p> <b>  Secure Payments  </b><br />
                        Sale and secure checkout
                    </p>
                </div>

            </div>

            <div className="cont1">
                <div className="row akrow p-5">
                    <div className="container col-lg-6 col-md-12 contb pt-lg-4 pt-md-0">
                        <h5>  E-Commerce Website </h5>
                        <h3>  Devlopment </h3> <h3> Portfolio </h3> <br />
                        <h5> by himanshuverse.com  </h5>
                    </div>
                    <div className="col-lg-6 col-md-12 p-lg-5 mt-lg-0 mt-5 wimg">
                        <img src={wbimages[ind]} width={"500px"} />
                    </div>
                </div>
            </div>

            <div className="sidlog mt-5">
                <p> Get Best Results <img src={log} width={"50px"} /> </p>
            </div>
            <div className="container">
                <div className="row mt-5">
                    <div className="col-lg-6 col-md-12" >
                        <div className="lig">
                            <button> Shop Now <i class="fa-solid fa-arrow-right"></i> </button>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 md-mt-3">
                        <div className="rig">

                            <button> Shop Now <i class="fa-solid fa-arrow-right"></i> </button>
                        </div>
                    </div>
                </div>
            </div>
            <Shop />
        </>
    );
}

export default Home;